import React, {useEffect, useRef, useState} from "react";
import AppContentWrapper from "../AppContentWrapper/AppContentWrapper";
import "./OwnerAnnuitantSummary.css";
import {Button, Col, Row} from "react-bootstrap";
import {
  ANNUITANT_TYPE,
  APP_SECTION,
  ENTITY_TYPE,
  PARTY, OWNER_TYPE,
  PAGES, typeForParty
} from "../../../scripts/constants";
import {mygaSession} from "../../../scripts/myga-session";
import {NassauLog} from "../../../scripts/myga-utils";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Resources from "../../../Resources/Resources";
import {
  canAddParty,
  hasAnnuitant,
  hasOwner,
  isEachPartyRelationshipOK, reconcileBenes,
  reconcileParties,
  reconcilePayors
} from "../../../scripts/validation";
import PopoverTooltip from "../../../components/PopoverTooltip";
import {saveApplication as syncApplication} from "../../../scripts/sync-manager";
import {MM_PRODUCT_DTO} from "../../../scripts/myga-model";

function OwnerAnnuitantSummary(props) {
  const [productId,setProductId] = useState('');
  const [parties, setParties] = useState([]);
  const [addButtonShow,setAddButtonShow] = useState(true);
  const errorMessage = useRef(null);
  
  useEffect(() => {
    setParties([...mygaSession.getCurrentAppParties()]);
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    mygaSession.setCurrentAppSectionData(APP_SECTION.parties,parties);
    if (reconcilePayors()) {
      syncApplication(APP_SECTION.parties).catch(err => {NassauLog(err)});

    }
    const reconciled = reconcileParties(parties);
    if (reconciled) {
      mygaSession.setCurrentAppParties(reconciled);
      syncApplication(APP_SECTION.parties).catch(err => {NassauLog(err)});
      setParties(reconciled);
      // 2022.05.19.ADivelbiss - currently assume all parties applied to all selected products.
      const nextProductDTOs = [...mygaSession.getCurrentAppProductDTOs()];
      nextProductDTOs.forEach(dto=>dto[MM_PRODUCT_DTO.parties]=parties);
      mygaSession.setCurrentAppProductDTOs(nextProductDTOs)
      syncApplication(APP_SECTION.products).catch(err => {NassauLog(err)});
    }
    
    // update the add button
    setAddButtonShow(canAddParty());
    
  }, [parties]);

  const partyRelationshipToOwner = party => {
    return party[PARTY.ownerType]===OWNER_TYPE.primary ? "Self" : party[PARTY.relationshipToOwner];
  }
  
  const partyRelationshipToAnnuitant = party => {
    return party[PARTY.annuitantType]===ANNUITANT_TYPE.primary ? "Self" : party[PARTY.relationshipToAnnuitant];
  }
  
  const saveApplication = useRef(null);
  saveApplication.current = async () => {
    const benes = reconcileBenes();
    if (benes) {
      mygaSession.setCurrentAppSectionData(APP_SECTION.benes, benes);
      await syncApplication(APP_SECTION.benes);
      // 2022.05.19.ADivelbiss - currently assume all benes applied to all selected products.
      const nextProductDTOs = [...mygaSession.getCurrentAppProductDTOs()];
      nextProductDTOs.forEach(dto=>dto[MM_PRODUCT_DTO.benes]=benes);
      mygaSession.setCurrentAppProductDTOs(nextProductDTOs)
      syncApplication(APP_SECTION.products).catch(err => {NassauLog(err)});
    }
  }

  const onBackPressed = async () => {
    await saveApplication.current()
  }

  const onNextPressed = async () => {
    await saveApplication.current()
  }

  const validate = () => {
    const data = {parties: mygaSession.getCurrentAppParties()};
    // make sure that we have an owner and annuitant
    if (!hasOwner(data)) {
      errorMessage.current = "Please add or select a party to be the Owner";
      // NassauLog(`OwnerAnnuitantSummary: errorMessage "${errorMessage.current}"`);
      return false;
    }
    if (!hasAnnuitant(data)) {
      errorMessage.current = "Please add or select a party to be the Annuitant";
      // NassauLog(`OwnerAnnuitantSummary: errorMessage "${errorMessage.current}"`);
      return false;
    }
    if (!isEachPartyRelationshipOK(data)) {
      errorMessage.current = "Please check the party relationships. Update any listed as \"None\"";
      // NassauLog(`OwnerAnnuitantSummary: errorMessage "${errorMessage.current}"`);
      return false;
    }
    errorMessage.current = '';
    return true;
  };

  const addPerson = () => {
    mygaSession.setCurrentPartyIndex(parties.length);
    props.updatePage(PAGES.pageAppIdOwnerAnnuitant, PAGES.pageAppIdOwnerAnnuitantSummary, true);
  }

  const editParty = index => {
    mygaSession.setCurrentPartyIndex(index);
    props.updatePage(PAGES.pageAppIdOwnerAnnuitant, PAGES.pageAppIdOwnerAnnuitantSummary, true);
  }

  const deletePerson = (person, index) => {
    let newList = [...parties];
    
    newList.splice(index, 1);
    
    setParties(newList);
  }

  return <AppContentWrapper
    onBackPressed={onBackPressed}
    onNextPressed={onNextPressed}
    validateOnNext={validate}
    updatePage={props.updatePage}
    errorMessage={errorMessage.current}>

    <div className="summary-table mb-3">
      <Row className="header border-bottom">
        <Col xs={6} md={2} xl={2} className="name">Name</Col>
        <Col xs={3} sm={3} md={2} className="type d-none d-md-block">Type</Col>
        <Col xs={2} sm={2} md={2} className="d-none d-md-block">Relation To Owner</Col>
        <Col xs={2} sm={2} md={2} className="d-none d-md-block">Relation To Annuitant</Col>
        <Col></Col>
      </Row>
      {
        parties.map((party, index) => {
          return (
            <Row key={index} className="page-data-entry border-bottom align-content-center">
              <Col xs={6} md={2} xl={2} className="my-auto name">
                {
                    party[PARTY.entityType]===ENTITY_TYPE.trust ?
                    `${party[PARTY.trustName]}` :
                    `${party[PARTY.firstName]} ${party[PARTY.lastName]}`
                }&nbsp;
                <PopoverTooltip className="d-inline-block d-md-none" icon={'ellipsis-h'} content={
                  <div>
                    <p><b>Type:</b> {typeForParty(party)}</p>
                    <p><b>Relation To Owner:</b> {partyRelationshipToOwner(party)}</p>
                    <p><b>Relation To Annuitant:</b> {partyRelationshipToAnnuitant(party)}</p>
                  </div>
                }/>
              </Col>
              <Col xs={3} sm={3} md={2} className="my-auto type d-none d-md-block">{typeForParty(party)}</Col>
              <Col xs={2} sm={2} md={2} className="my-auto d-none d-md-block">{partyRelationshipToOwner(party)}</Col>
              <Col xs={2} sm={2} md={2} className="my-auto d-none d-md-block">{partyRelationshipToAnnuitant(party)}</Col>
              <Col className={'my-auto'}>
                <Row className={'align-content-center'}>
                  <Col className="my-auto summaryButton">
                    {/*<Col xs={(parties.length === 1) ? 3 : 2}*/}
                    {/*     sm={(parties.length === 1) ? 4 : 2}*/}
                    {/*     xl={(parties.length === 1) ? 2 : 1}*/}
                    {/*     className="my-auto summaryButton">*/}
                    <Button id={`editParty_${index}`} className={'btn-edit-remove myga-edit test-enabled'}
                            onClick={() => editParty(index)}>
                      <FontAwesomeIcon id={`editPartyIcon_${index}`} className={'test-enabled '} icon={Resources.Icons.Pencil}/>
                    </Button>
                  </Col>
                  {party.type !== 'Owner' && (
                      <Col className="my-auto summaryButton">
                        {/*<Col xs={2} sm={2} xl={1} className="my-auto summaryButton">*/}
                        <Button id={`deleteParty_${index}`} className={'btn-edit-remove myga-trash test-enabled'}
                                onClick={(event) => deletePerson(party, index)}>
                          <FontAwesomeIcon id={`deletePartyIcon_${index}`} className={'test-enabled'} icon={Resources.Icons.TrashCan}/>
                        </Button>
                      </Col>
                  )}
                </Row>
              </Col>
            </Row>
          )})
      }
    </div>
    {addButtonShow && (
        <Row className="text-center pt-3">
          <Col>
            <Button id={'add_person'} className={'test-enabled nsre-button add-button'} variant="primary" onClick={addPerson}>ADD</Button>
          </Col>
        </Row>
    )}
  
  </AppContentWrapper>
}

export default OwnerAnnuitantSummary;